module.exports = __webpack_public_path__ + "img/red_020.e36f4ce5.png";